import clsx from 'clsx'
import React from 'react'
import style from './AutoRow.module.css'

const AutoRow = ({
    children,
    alignTop = false,
    alignBottom = false,
    noWrap = false,
    gridGap = undefined,
    between = false,
    className = '',
}) => {
    const _className = clsx(
        style.root,
        alignTop && style.alignTop,
        alignBottom && style.alignBottom,
        noWrap && style.noWrap,
        between && style.between,
        className,
    )
    return (
        <div style={{ gridGap }} className={_className}>
            {children}
        </div>
    )
}

export default AutoRow
